module.exports = __webpack_public_path__ + "static/media/gal-6.b41f04ff.jpeg";